import { idempotencyHeaders, platformErrorMessage } from '@/apps/ingestion/services/_platformClient';
import { platformApi } from '@/lib/platform-api';
import type { components } from '@/types/platform-api';

export type WhatsAppRate = components['schemas']['WhatsAppRateResponse'];
export type WhatsAppRateFees = components['schemas']['SaveWhatsAppRateRequest'];

const RATES_PATH = '/platform/v1/communications/admin/whatsapp-rates';

export async function fetchWhatsAppRates(): Promise<WhatsAppRate[]> {
  const { data, error } = await platformApi.GET(RATES_PATH);
  if (error || !data) throw new Error(platformErrorMessage(error, 'Failed to load WhatsApp rates'));
  return data.data;
}

/** Recipient countries with delivered WhatsApp messages and no rate, as the costing worker last saw them. */
export async function fetchWhatsAppMissingCountries(): Promise<string[]> {
  const { data, error } = await platformApi.GET(`${RATES_PATH}/missing`);
  if (error || !data) throw new Error(platformErrorMessage(error, 'Failed to load countries missing a WhatsApp rate'));
  return data.countries;
}

/** Sets the country's fees from today and costs the messages that were waiting for them. */
export async function saveWhatsAppRate(body: WhatsAppRateFees): Promise<WhatsAppRate> {
  const { data, error } = await platformApi.POST(RATES_PATH, { headers: idempotencyHeaders(), body });
  if (error || !data) throw new Error(platformErrorMessage(error, 'Failed to save the WhatsApp rate'));
  return data;
}
